import { Icon, List } from '@atom/mui';
import { CloseIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { AssetDetail, SearchAsset } from '@atom/types/asset';
import { InventoryAssetDetailType } from '@atom/types/inventory';
import schemaUtilities from '@atom/utilities/schemaUtilities';

const { ListItem, ListItemText } = List;

interface Props {
  asset?: InventoryAssetDetailType | SearchAsset | AssetDetail;
  assetRemovalDisabled?: boolean;
  onClick?: () => void;
  onRemove?: () => void;
  requireAsset?: boolean;
  'data-cy'?: string;
  removeDataCy?: string;
}

const styles = {
  choose: {
    boxSizing: 'border-box',
    minHeight: '4.125rem',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    color: colors.brand.blue,
    cursor: 'pointer',
  },
  listItem: {
    minHeight: '4.125rem',
    marginLeft: '-6px',
    padding: 0,
  },
  icon: {
    cursor: 'pointer',
  },
  iconContainer: {
    marginRight: '0.5rem',
  },
};

const InventoryAssetTile = ({
  asset,
  onClick,
  assetRemovalDisabled,
  onRemove,
  requireAsset,
  'data-cy': dataCy,
  removeDataCy,
}: Props) => {
  const displayText = requireAsset ? 'Add Asset *' : 'Add Asset';
  const icon = schemaUtilities.getSchemaIconFromSchemaOrAsset(asset, {
    imgOffset: '0',
    iconSize: '34px',
    marginTop: '0',
  });

  const showRemove = onRemove && !assetRemovalDisabled;

  return asset ? (
    <ListItem disableGutters style={styles.listItem}>
      <div style={styles.iconContainer}>{icon}</div>
      <ListItemText primary={asset.name} secondary={asset.assetType} />
      {showRemove && (
        <Icon
          style={styles.icon}
          onClick={onRemove}
          data-cy={removeDataCy}
          icon={CloseIcon}
        />
      )}
    </ListItem>
  ) : (
    <div onClick={onClick} style={styles.choose} data-cy={dataCy}>
      {displayText}
    </div>
  );
};

export default InventoryAssetTile;
